import { combineReducers } from 'redux'
import ledger from './ledger'

import authorization from './authorization'

const ablePortal = combineReducers({
  authorization,
  ledger,
})

export default ablePortal
